import httpService from '@Utils/httpService';

const baseUrl = 'api/Users';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getManagement(params) {
    return httpService.get({
      url: baseUrl+'/Management',
      params,
    });
  },
  typeHead( ) {
    return httpService.get({
      url: `${baseUrl}/typehead?all=true`
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  suspend(id, status) {
    return httpService.put({
      url: `${baseUrl}/${id}/${status}`,
    });
  },
  delete(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
};
